import { BASE_URL_API } from "../../constants";
import fetcher from "../../utils/fetcher";

export const api_chatbot = {
    // get history chat
    histories: async () => {
        let url = BASE_URL_API + "/ai-agent/today-chat";
        return fetcher(url, {
            method: "GET",
            credentials: "include",
        });
    },
    // post chat, ask question
    ask_question: async ({ question = null }) => {
        if (!question) return null;

        let url = BASE_URL_API + "/ai-agent/ask";

        return fetcher(url, {
            method: "POST",
            credentials: "include",
            body: JSON.stringify({
                question,
            }),
        });
    },
};
